import {
  REMOVE_OPEN_VFD_TASK,
  SET_OPEN_VFD_TASKS,
  SET_VFD_PATIENT_DETAILS,
  SET_VFD_PATIENT_TOKEN,
  initialState,
} from './constants'

export const vfdReducer = (
  state: VfdState = initialState,
  action:
    | ReducerActions<PatientTask[]>
    | ReducerActions<string>
    | ReducerActions<PatientDetails>
): VfdState => {
  const { type, payload } = action

  switch (type) {
    case SET_OPEN_VFD_TASKS: {
      const vfdOpenTasks = Array.isArray(payload)
        ? (payload as PatientTask[]).filter(({ status }) => status === 'open')
        : []
      return {
        ...state,
        vfdOpenTasks,
      }
    }

    case REMOVE_OPEN_VFD_TASK: {
      const vfdOpenTasks = state.vfdOpenTasks.filter(
        ({ id }) => id !== (payload as string)
      )
      return {
        ...state,
        vfdOpenTasks,
      }
    }

    case SET_VFD_PATIENT_TOKEN: {
      const patientToken = payload as string
      return {
        ...state,
        vfdPatientAuth: {
          ...state.vfdPatientAuth,
          patientToken,
        },
      }
    }

    case SET_VFD_PATIENT_DETAILS: {
      const patient = payload as PatientDetails
      return {
        ...state,
        vfdPatientAuth: {
          ...state.vfdPatientAuth,
          patient,
        },
      }
    }

    default:
      return state
  }
}
